module.exports = __webpack_public_path__ + "img/block-green.e31995bc.webp";